import BigNav from './big-nav';
import PropTypes from 'prop-types';
import React from 'react';
import SmallNav from './small-nav';

import './navbar.scss';

const NavBar = ({navItems, entity}) => {
  return (
    <nav className="main">
      <BigNav items={navItems} entity={entity}/>
      <SmallNav items={navItems} entity={entity}/>
    </nav>
  );
};

NavBar.propTypes = {
  entity: PropTypes.object.isRequired,
  navItems: PropTypes.array.isRequired
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/shared/navbar/navbar.js